/* eslint-disable no-param-reassign */
/* eslint-disable security/detect-object-injection */
import { audiUSAModelRegistry } from './constants';

export function updateTrackers(model, localStorageState) {
  const modelInfo = audiUSAModelRegistry[model] || {};
  const modelProperties = modelInfo.bodyType || [];

  modelProperties.forEach((modelProperty) => {
    localStorageState.updatedBodyTypeTracker[modelProperty] =
      (localStorageState.updatedBodyTypeTracker[modelProperty] || 0) + 1;
  });

  localStorageState.updatedPriceTracker[modelInfo.category] =
    (localStorageState.updatedPriceTracker[modelInfo.category] || 0) + 1;
}
